import { useMemo, useEffect, useState } from 'react';
import io from 'socket.io-client';
import { toast } from 'react-toastify';

const useSocket = ( serverPath ) => {
    const token = localStorage.getItem('token');
    const sockets = useMemo( () => io.connect( serverPath, {
        transports: ['websocket'],
        autoConnect: true,
        forceNew: true,
        query: {
            'nun-otoken': token
        }
    })
    , [ serverPath ] );
    const [ online, setOnline ] = useState(false);

    useEffect(() => {
        setOnline( sockets.connected );
    }, [ sockets ])

    useEffect( () => {
        sockets.on('connect', () => {
            setOnline( true );
        })

    }, [ sockets ])

    useEffect( () => {

        sockets.on('disconnect', () => {
            setOnline( false );
        })

    }, [ sockets ])

    useEffect(() => {
        const debugHandler = (event, ...args) => {
            if (['connect', 'disconnect', 'connect_error', 'reconnect'].includes(event)) return;
            const data = args.length > 0 ? ` → ${JSON.stringify(args[0]).substring(0, 60)}` : '';
            toast.info(`🔌 ${event}${data}`, {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                style: { fontSize: 12, maxWidth: 350 }
            });
        };
        sockets.onAny(debugHandler);
        return () => {
            sockets.offAny(debugHandler);
        };
    }, [sockets]);

    return {
        sockets,
        online
    }
}
export default useSocket;